
import logo from './../../../Styles/images/logo.png'
import pvHorizontal from './../../../Styles/Logos/PVHorizontal.png';
import React, {useState} from "react";
import Image, { propTypes } from "react-bootstrap/Image";
import { Container,Row,Col, Card, Table,Tab,Tabs, Badge, Button, } from "react-bootstrap";
import './../../../Styles/Admin.css';
import { WadiStyles } from '../../../Styles/WadiStyles';
import PropTypes from 'prop-types';
import DatePicker from "react-date-picker";


const AdminDashboardTableComponent = props => {
    function handleViewClick(selection){
        props.updateView(selection)
    }
    function handleADDDate(){
        var date = new Date(dateValue)
        date.setDate(date.getDate() + 1)
        onChangeDate(date);
    }
    function handleSubtractDate(){
        var date = new Date(dateValue)
        date.setDate(date.getDate() - 1)
        onChangeDate(date);
    }
    const [dateValue, onChangeDate]= useState(new Date());



    /** The consts below would be pulled from DB */
    let bookingMapping =[{time:"11 AM",name:"The Watson Party",location:"barrel",size:4},{time:"11:45 AM",name:"The Smithe Party",location:"barrel",size:2},{time:"12:30 PM",name:"The Jamali Party",location:"barrel",size:3}, {time:"3:30 PM", name:"The Johnson Party",location:"barrel",size:2}];

    let [style, setStyle] = useState(WadiStyles.dashboard.card); 

    return(
        <>
        {/** NOTE -- TO HIDE SCROLL BAR WE NEED TO DIFFERENTIATE BETWEEN BROWSER TYPE */}
        <Row style={{paddingBottom:'1vh'}}>
            <Col>
                <Button style={WadiStyles.dashboard.buttonCircle} onClick={()=>handleSubtractDate()}>-</Button>
                <DatePicker onChange={onChangeDate} value={dateValue} />
                <Button style={WadiStyles.dashboard.buttonCircle} onClick={()=>handleADDDate()}>+</Button>
            </Col>
        </Row>
        <Row>
        
        {props.locations.map(function (location){
                let index=0;
                return(
                    <Col>
                        <Card style={{backgroundColor:'#d1d1ca',height:'75vh', backgroundColor:'#d1d1ca', overflowY:'auto', scrollbarWidth:'none'}}>
                            <Card.Header style={{color:'#4e6437', fontWeight:'bolder'}} >
                                {location.name}
                            </Card.Header>
                            <Row>  
                                <Tabs
                                    defaultActiveKey="profile"
                                    id="uncontrolled-tab-example"
                                    className="mb-3"
                                    fill
                                >
                                    <Tab eventKey="home" title="Table 1">
                                    <Card.Body style={{color:'#4b1c38', fontWeight:'bold'}}>
                                            <Table>
                                                <tbody>
                                                    {props.hours.map(function (hour){
                                                        let currentIndex=index;
                                                        let lenght = bookingMapping.length;
                                                        if(hour === bookingMapping[currentIndex].time){
                                                            if(index<lenght-1){
                                                                index=index+1;
                                                            }
                                                            return( 
                                                            <tr style={{color:'#4b1c38', fontWeight:'bold'}}>
                                                                <td>{hour}</td>
                                                                    <Card style={style} onClick={()=>handleViewClick('Edit')}>
                                                                        <Row>
                                                                            <Col>{bookingMapping[currentIndex].name}</Col>
                                                                            <Col sm='1' style={{paddingRight:'2vw'}}>{bookingMapping[currentIndex].size}</Col>
                                                                        </Row>
                                                                    </Card>
                                                            </tr>
                                                            )
                                                        } else {
                                                            return(
                                                                <tr style={{color:'#4e6437', fontWeight:'bold'}}>
                                                                    <td>{hour}</td> 
                                                                        <td></td>
                                                                </tr>
                                                                )
                                                        }
                                                    })}
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Tab>
                                    
                                    <Tab eventKey="profile" title="Table 2">
                                    <Card.Body style={{color:'#4b1c38', fontWeight:'bold'}}>
                                            <Table  responsive>
                                                <tbody>
                                                    {props.hours.map(function (hour){
                                                        let currentIndex=index;
                                                        let lenght = bookingMapping.length;
                                                        if(hour === bookingMapping[currentIndex].time){
                                                            if(index<lenght-1){
                                                                index=index+1;
                                                            }
                                                            return(
                                                                <tr style={{color:'#4b1c38', fontWeight:'bold'}}>
                                                                <td>{hour}</td>
                                                                <Card style={WadiStyles.dashboard.card} onClick={()=>handleViewClick('Edit')}>
                                                                    <Row>
                                                                        <Col>{bookingMapping[currentIndex].name}</Col>
                                                                        <Col sm='1' style={{paddingRight:'2vw'}}>{bookingMapping[currentIndex].size}</Col>
                                                                    </Row>
                                                                </Card>
                                                            </tr>
                                                            )
                                                        } else {
                                                            return(
                                                                <tr style={{color:'#4e6437', fontWeight:'bold'}}>
                                                                    <td>{hour}</td> 
                                                                    <td></td>
                                                                </tr>
                                                                )
                                                        }
                                                        
                                                    })}
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Tab>
                                    <Tab eventKey="contact" title="Table 3">
                                    <Card.Body style={{color:'#4b1c38', fontWeight:'bold'}}>
                                            <Table  responsive>
                                                <tbody>
                                                    {props.hours.map(function (hour){
                                                        let currentIndex=index;
                                                        let lenght = bookingMapping.length;
                                                        if(hour === bookingMapping[currentIndex].time){
                                                            if(index<lenght-1){
                                                                index=index+1;
                                                            }
                                                            return(
                                                            <tr style={{color:'#4b1c38', fontWeight:'bold'}}>
                                                                <td>{hour}</td>
                                                                <Card style={WadiStyles.dashboard.card} onClick={()=>handleViewClick('Edit')}>
                                                                    <Row>
                                                                        <Col>{bookingMapping[currentIndex].name}</Col>
                                                                        <Col sm='1' style={{paddingRight:'2vw'}}>{bookingMapping[currentIndex].size}</Col>
                                                                    </Row>
                                                                </Card>
                                                            </tr>
                                                            )
                                                        } else {
                                                            return(
                                                                <tr style={{color:'#4e6437', fontWeight:'bold'}}>
                                                                    <td>{hour}</td> 
                                                                    <td></td>
                                                                </tr>
                                                            )
                                                        }
                                                    })}
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Tab>
                                </Tabs>
                            </Row>
                        </Card>
                    </Col>
                );
        })} 
        </Row>
    </>
    )
   
}
AdminDashboardTableComponent.defaultProps = {

}
AdminDashboardTableComponent.propTypes = {
    view: PropTypes.string,
    updateView:PropTypes.func,

    hours: PropTypes.arrayOf(String),
    bookingMapping: PropTypes.arrayOf(Map),
    locations: PropTypes.arrayOf(Map),
}

export default (AdminDashboardTableComponent);
